/*
 *
 *  remotes
 *
 */

import api from "../../helpers/Api"
// import constantName from "./key"

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method) {
  if (method === "post") {
    return api
      .post(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

/**
 *
 * @param {integer} id
 * @returns
 */
export function loadEventDateRecords(event_date) {
  console.log("event_date", event_date)
  // alert("3")
  return api
    .get(`/get_all_lead_event_date`, event_date)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadRecordEventDetails(id) {
  let payload = { status: "active", leadId: id }

  return api
    .post(`/get_all_lead_event_detail`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

/**
 *
 * @param {object} record
 * @returns
 */

export async function createEventRecord(eventUpdate) {
  console.log("inside api call------------", eventUpdate)
  try {
    const response = await api.post(
      `/add_lead_event_detail`,
      eventUpdate
    )
    console.log(response.data, "response data from api call")
    //return response.data
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export async function updateEventRecord(eventUpdate) {
  try {
    console.log("Updated Api data ---> ")

    const response = await api.put(
      `/update_lead_event_detail_by_id`,
      eventUpdate
    )
    console.log(response.data, "response updated data")
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 *
 * @param {integer} id
 * @returns
 */
export function deleteEventRecord(eventRemoveId) {
  console.log(eventRemoveId, "eventRemoveId")
  return api
    .delete(`/delete_lead_event_detail_by_id?leadEventDetailId=`+eventRemoveId
    )
    .catch((error) => Promise.reject(error))
}


///Offer list
/**
 *
 * @param {integer} id
 * @returns
 */
 export function loadOfferDetails(offer_list) {
  // let payload = { status: "active", leadId: id }

  return api
    .get(`/get_all_lead_offer_date`, offer_list)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

/**
 *
 * @param {object} record
 * @returns
 */

export async function createOfferDetails(offerList) {
  console.log("inside api call------------", offerList)
  try {
    const response = await api.post(
      `/add_offer`,
      offerList
    )
    console.log(response.data, "response data from api call")
    //return response.data
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

//Venue

/**
 *
 * @param {integer} id
 * @returns
 */
 export function loadVenueDetails(id) {
  let payload = { status: "active", leadId: id }

  return api
    .post(`/get_all_city_venue`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
//Venue Name

/**
 *
 * @param {integer} id
 * @returns
 */
 export function loadVenueNameDetails(id) {
  let payload = { status: "active", leadId: id }

  return api
    .post(`/get_all_venue`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}


 export function addVenueDetails(venueData) {

  return api
    .post(`/add_venue`, venueData)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

 export function updateVenueDetails(venueData) {

  return api
    .put(`/update_venue_by_id`, venueData)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
//Venue Locations

/**
 *
 * @param {integer} id
 * @returns
 */
 export function loadVenueLocationDetails(id) {
  let payload = { status: "active", leadId: id }

  return api
    .post(`/get_all_venue_location`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}


 export function addVenueLocationDetails(locationData) {

  return api
    .post(`/add_venue_location`, locationData)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

 export function updateVenueLocationDetails(locationData) {

  return api
    .put(`/update_venue_location_by_id`, locationData)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}


const remotes = {
  loadRecordsMetaData,
  loadEventDateRecords,
  loadRecordEventDetails,
  createEventRecord,
  updateEventRecord,
  deleteEventRecord,
  loadVenueDetails,
  loadVenueNameDetails,
  addVenueDetails,
  updateVenueDetails,
  loadVenueLocationDetails,
  addVenueLocationDetails,
  updateVenueLocationDetails,
}

export default remotes
